import gql from 'graphql-tag';

export const subOfferEdited = gql`
  subscription OfferEdited {
        offerEdited {
            title
        }
    }`;